// Convierte una imagen a WebP (calidad 0.85). Si ya es webp o es string, la devuelve igual.
export default async function convertToWebP(file: File): Promise<File> {
    return new Promise((resolve, reject) => {
        if (typeof file === 'string') { resolve(file as unknown as File); return; }
        if (file.type === 'image/webp') { resolve(file); return; }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target?.result as string;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                if (!ctx) { reject(new Error('Could not get canvas context')); return; }
                ctx.drawImage(img, 0, 0);
                canvas.toBlob(
                    (blob) => {
                        if (!blob) { reject(new Error('Could not convert image to WebP')); return; }
                        const webpFile = new File(
                            [blob],
                            `${file.name.split('.')[0] || 'image'}.webp`,
                            { type: 'image/webp' }
                        );
                        resolve(webpFile);
                    },
                    'image/webp',
                    0.85
                );
            };
            img.onerror = () => reject(new Error('Failed to load image'));
        };
        reader.onerror = () => reject(new Error('Failed to read file'));
    });
}
